/**
 * A LAZY PART, LOADED THE FIRST TIME IT IS SHOWN (the perf overhaul, Stage 1). The rarely used screens - the
 * terrain editor, the settings, the locks - were in the bundle every table downloads and compiles before its first
 * frame. Given `React.lazy(() => import(...))` as `component`, this renders nothing until `show` is first true, then
 * mounts it (loading its chunk, with no fallback: a dialog appears a moment later) and KEEPS it mounted, closed or
 * open, so whatever it keeps across a close - the terrain editor's open tab - is kept as before.
 *
 * @param {object} props
 * @param {boolean} props.show - passed on to the component, which draws itself closed when false
 * @param {import('react').ComponentType<any>} props.component - a `React.lazy` component taking `show`
 */
import { Suspense, useState } from 'react';

export default function LazyWhenShown({ show, component: Component, ...props }) {
  const [shown, setShown] = useState(!!show);
  // Derived in render, React's pattern for state that follows a prop: it only ever turns on.
  if (show && !shown) setShown(true);
  if (!shown) return null;
  return (
    <Suspense fallback={null}>
      <Component show={show} {...props} />
    </Suspense>
  );
}
